<div class="listing-card" [routerLink]="['/announcements', listing.id]">
  <div class="card-image">
    <img [src]="listing.previewImageUrl || listing.imageUrls?.[0] || 'assets/no-image.jpg'" [alt]="listing.title || 'Elan'" loading="lazy">
    <div class="role-badge" [class.agent]="listing.ownerType === 'agent'">
      {{ listing.ownerType === 'agent' ? 'Vasitəçi' : 'Mülkiyyətçi' }}
    </div>
    @if (listing.isVip) {
      <div class="vip-badge">
        <i class="fas fa-crown"></i>
      </div>
    }
  </div>
  <div class="card-content">
    <div class="price-row">
      <span class="price">{{ listing.price | currency:'AZN':'symbol-narrow':'1.0-0' }}</span>
      @if (listing.isVip) {
        <span class="vip-icon" title="VIP"><i class="fas fa-gem"></i></span>
      }
    </div>
    <div class="specs">
      @if (listing.rooms || listing.roomCount) { {{ formattedRooms }} otaqlı | }
      @if (listing.area_m2 || listing.areaSquareMeters) { {{ listing.area_m2 || listing.areaSquareMeters }} m² | }
      @if (listing.floor !== undefined && listing.floor !== null) { {{ formattedFloor }} mərtəbə }
    </div>
    <div class="location">{{ displayLocation() }}</div>
    <div class="property-type">{{ displayPropertyType() }}</div>
    <div class="date">{{ (listing.createdDate || listing.createdAt) | date:'dd.MM.yyyy HH:mm' }}</div>
  </div>
</div>
